import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgArchiproSymbolLogo = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 405,
	height: 306,
	viewBox: "0 0 405 306",
	fill: "none",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			d: "M255.651 0.0229167V0L285.038 53.5385L285.114 53.7327H203.241C202.324 53.6081 201.381 53.7739 200.615 54.1948C199.849 54.6157 199.32 55.2583 199.141 55.9856C178.75 99.0187 158.331 142.041 137.886 185.052L136.574 187.958H345.959C346.881 187.875 347.808 188.066 348.565 188.494C349.321 188.921 349.853 189.556 350.059 190.276C368.072 228.129 386.099 266.003 404.139 303.899L405 305.858H326.853C326.117 305.938 325.371 305.793 324.764 305.455C324.156 305.116 323.73 304.607 323.572 304.03C313.295 282.263 302.976 260.496 292.617 238.729C292.422 238.103 291.938 237.558 291.263 237.201C290.587 236.844 289.768 236.702 288.968 236.803H116.073C115.244 236.686 114.389 236.827 113.687 237.198C112.984 237.569 112.488 238.14 112.301 238.795C101.969 260.562 91.6095 282.426 81.2226 304.389C81.0852 304.882 80.7251 305.317 80.2111 305.612C79.697 305.907 79.0647 306.041 78.4344 305.989H0C0.120591 305.701 0.224551 305.426 0.324109 305.163L0.324331 305.162L0.324459 305.162C0.495565 304.71 0.653708 304.291 0.860982 303.899C17.726 268.376 34.591 232.863 51.456 197.361C82.4526 132.061 113.422 66.8472 144.364 1.72075C144.521 1.1781 144.929 0.702336 145.506 0.387851C146.083 0.0733666 146.788 -0.0568806 147.48 0.0229167H255.651Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M334.993 53.9994C336.78 53.9994 338.232 55.4583 338.201 57.2423C336.468 156.559 255.279 236.538 155.378 236.538H112.844V183.461H155.378C227 183.461 285.061 125.499 285.061 53.9994H334.993Z",
			fill: "white"
		})
	]
});
const ForwardRef = forwardRef(SvgArchiproSymbolLogo);
export { ForwardRef as ReactComponent };
